import { Component, inject, OnInit, signal } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { UpcomingService } from "../../../../../../../../../shared/src/lib/services/upcoming.service";
import { SportHighlightsComponent } from "../../../../home/sport-highlights/sport-highlights.component";
import { headerSports } from "../../../../../../../assets/constants/market";
import { AsyncPipe } from "@angular/common";

@Component({
  selector: "app-upcoming-sub-tab",
  standalone: true,
  imports: [SportHighlightsComponent, AsyncPipe],
  template: `
    @if (markets(); as marketData) {
      <app-sport-highlights [data]="marketData" [showHeader]="false"></app-sport-highlights>
    }
  `,
  styles: [``]
})
export class UpcomingSubTabComponent implements OnInit {
  route = inject(ActivatedRoute);
  upcomingService = inject(UpcomingService);
  markets = signal<{ key: string; value: any[] } | null>(null);
  sportName: string = "";
  sportId: string = "";

  ngOnInit() {
    this.route.parent?.parent?.params.subscribe(params => {
      this.sportName = params["sport"];
      this.sportId = headerSports.get(this.sportName)?.id || "4"; // Default to cricket if not found
      
      this.route.params.subscribe(subParams => {
        const date = subParams["date"] || "today";
        this.fetchMarkets(this.sportId, date);
      });
    });
  }

  fetchMarkets(sportId: string, date: string) {
    this.upcomingService.getUpcomingMarkets(sportId, date).subscribe(response => {
      if (response && response.data) {
        this.markets.set({
          key: `upcoming_${this.sportName}`,
          value: response.data
        });
      } else {
        this.markets.set(null);
      }
    });
  }
}
